import {updateControl} from '../../actions/control'
import {getDefaultControlObject} from '../getDefaultControlObject'

export function resetControl() {
	const newControlObject=getDefaultControlObject()
	return updateControl(newControlObject)
}

